import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { rootTranslationRef } from './root';

export const rootTranslations = createTranslationResource({
  ref: rootTranslationRef,
  translations: {
    'pt-BR': () => import('./root-pt-BR'),
  },
});
